import { useQuery } from "@tanstack/react-query";
import userPreferencesService from "../api/userPreferencesService";

export const useUserPreferences = (userId) => {
  const { getUserPreferences } = userPreferencesService();

  return useQuery({
    queryKey: ["get-user-preferences", userId],
    queryFn: async () => {
      const res = await getUserPreferences(userId);
      return res.data;
    },
    enabled: !!userId,
  });
};
